import React, { useRef, useEffect } from 'react'
import { buildRoseSVG } from '../utils/roseUtils'

const RosePlotSVG = ({ data, tag, value, calm, width, height }) => {
  const containerRef = useRef(null)

  useEffect(() => {
    if (!containerRef.current) return
    containerRef.current.innerHTML = ''
    let svg2 = document.createElementNS("http://www.w3.org/2000/svg", 'svg')

    if (width && height) {
      svg2.setAttribute("width", width);
      svg2.setAttribute("height", height);
    }
    
    buildRoseSVG(svg2, data || [], tag || '', value, calm)
    containerRef.current.innerHTML = (new XMLSerializer()).serializeToString(svg2)
  }, [data, tag, value, calm, width, height])

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    />
  )
}

export default RosePlotSVG
